module.exports = __webpack_public_path__ + "img/logo_darenhoutai.e0297a3e.png";